import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import { findInVNode } from 'utils/vnode';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			megaverseShowFooter: false,
			megaverseShowArrow: false
		};
		this.onMegaverseShowFooter = this.onMegaverseShowFooter.bind(this);
		this.onMegaverseShowArrow = this.onMegaverseShowArrow.bind(this);
	}
	componentDidMount() {
		super.componentDidMount();
		Store.on('MEGAVERSE_SHOW_FOOTER', this.onMegaverseShowFooter);
		Store.on('MEGAVERSE_SHOW_ARROW', this.onMegaverseShowArrow);
	}

	componentDidUnmount() {
		super.componentDidUnmount();
		Store.off('MEGAVERSE_SHOW_FOOTER', this.onMegaverseShowFooter);
		Store.off('MEGAVERSE_SHOW_ARROW', this.onMegaverseShowArrow);
	}

	onMegaverseShowFooter(bool) {
		this.setState({ megaverseShowFooter: bool });
	}

	onMegaverseShowArrow(bool) {
		this.setState({ megaverseShowArrow: bool });
	}

	render (props, state) {
		const base = super.render(props, state);
		const activePage = props.store.activePage;
		if (activePage === 'megaverse') {
			if (state.megaverseShowFooter) {
				base.attributes.class = joinClasses(base.attributes.class, s.megaverseShowFooter);
			}
			const scrollTopButton = findInVNode(base, '[key="inline-footer-scroll-top"]');
			if (scrollTopButton) {
				if (state.megaverseShowArrow) {
					scrollTopButton.attributes.class = joinClasses(scrollTopButton.attributes.class, s.megaverseShowArrow);
				}
				scrollTopButton.attributes = {
					...scrollTopButton.attributes,
					trigger: () => {
						Store.emit('MEGAVERSE_SCROLL_TO_TOP');
					}
				};
			}
		}
		return base;
	}


}
